'use client';
import { jsx } from 'react/jsx-runtime';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

let i = renderWithRef('TextInputWithFloatingLabel', null, (e, o)=>{
    let { children: i } = e;
    return jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: o,
            props: e,
            classNames: [
                'swan-vanilla-ignore',
                'swan-input-with-floating-label'
            ],
            children: i
        })
    });
});
const TextInputWithFloatingLabel = deprecatedComponent({
    description: 'Use the generic component InputWithFloatingLabel instead',
    displayName: 'TextInputWithFloatingLabel',
    root: i
});

export { TextInputWithFloatingLabel };
